function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 72 72"
}, props), React.createElement("circle", {
  cx: "35.798",
  cy: "35.798",
  r: "35.798",
  fill: "#fff"
}), React.createElement("path", {
  d: "M42.668 44.85l3.445-3.619a3.32 3.32 0 011.69-.948 3.216 3.216 0 011.908.173l4.198 1.76A3.39 3.39 0 0155.42 43.5c.372.575.574 1.253.58 1.948v8.076c-.004.473-.098.94-.278 1.373a3.51 3.51 0 01-.77 1.149 3.315 3.315 0 01-1.136.74 3.191 3.191 0 01-1.322.21C23.078 55.074 17.143 28.907 16.02 18.894a3.673 3.673 0 01.14-1.46c.144-.472.382-.906.697-1.273.315-.368.701-.662 1.132-.861A3.2 3.2 0 0119.357 15h7.427a3.21 3.21 0 011.858.604c.548.391.972.946 1.218 1.593l1.676 4.41c.246.634.309 1.331.18 2.003a3.547 3.547 0 01-.903 1.776l-3.444 3.618s1.983 14.1 15.3 15.845z",
  fill: "#59A3BD"
})));